import React from 'react'
import IMG1 from "../Images/DSC04189.jpg"
function Image() {
  return (
    <>
<img src={IMG1}  className="img" style={{width:"226px"}} alt='mahdi'/>
    </>
  )
}

export default Image